import React from "react";
import "./NotFound.css";

// Splits the unknown path into a leading "kept" part and the final segment we
// strike through, mirroring the design's broken-trail treatment. Falls back to
// the raw pathname when there's only a single segment.
function splitBrokenPath(pathname) {
  const clean = (pathname || "/").replace(/^\/+/, "").replace(/\/+$/, "");
  if (!clean) return { kept: "", broken: "" };
  const segments = clean.split("/");
  const broken = segments.pop();
  const kept = segments.length ? `${segments.join("/")}/` : "";
  return { kept, broken };
}

const DEFAULT_EYEBROW = "Error 404 — page not found";
const DEFAULT_TITLE = "This page could not be found.";
const DEFAULT_BODY =
  "The page you’re looking for has moved, or no longer exists. Check the address, or return to your workspace overview.";

function NotFound({ pathname, onHome, eyebrow, title, body }) {
  const { kept, broken } = splitBrokenPath(pathname);

  return (
    <div className="not-found">
      <div className="not-found__inner">
        <div className="not-found__eyebrow int404-rise">
          <span className="not-found__eyebrow-dash" aria-hidden="true" />
          {eyebrow || DEFAULT_EYEBROW}
        </div>

        <div className="not-found__numeral-wrap">
          <div className="not-found__numeral int404-rise" aria-hidden="true">
            <span>4</span>
            <span className="not-found__zero">0</span>
            <span>4</span>
          </div>
          <div className="not-found__scanline" aria-hidden="true" />
        </div>

        <h1 className="not-found__title int404-rise">{title || DEFAULT_TITLE}</h1>

        <p className="not-found__body int404-rise">{body || DEFAULT_BODY}</p>

        <div className="not-found__path int404-rise">
          <span className="not-found__path-host">app.jantro.io/</span>
          {kept && <span>{kept}</span>}
          <span className="not-found__path-broken">{broken}</span>
          <span className="not-found__caret" aria-hidden="true" />
        </div>

        {onHome && (
          <button type="button" className="not-found__home int404-rise" onClick={onHome}>
            Return to overview
            <span className="not-found__home-arrow" aria-hidden="true">
              &rarr;
            </span>
          </button>
        )}
      </div>
    </div>
  );
}

export default NotFound;
